module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/article-feed-326b724bca46431abc228285117ff1d8.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/article-feed.svg
// module id = qiWQ
// module chunks = 24